
<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true" 
(acceptEvent)="onRemoveprocedureClick()" (rejectEvent)="confirmModalActive = false" 
acceptText="Remove" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
<div role="body">
    Please confirm permanent removal of record.
</div>
</smt-modal>
<div class="page-header-outer">
  <div class="page-header">
      <h1>Procedures</h1>
      <div class="controls">
          <button [disabled]="!addButtonEnabled" (click)="onAddprocedureClick()"><span class="icon-plus"></span> Add New</button>
      </div>
  </div>
</div>
<div class="content-inner">
    <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">           
                <div class="filter-sort">
                    <div class="filter">
                        <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Procedure">
                    </div>
                    <div class="sort">
                        <label class="compact">Sort</label>
                        <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                            <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                                {{type}}
                            </option>
                        </select> 
                        <a class="arrow compact" (click)="onChangeSortOrder()" 
                            [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                    </div>
                </div>
                <ul class="adminListScroll" > 
                    <li *ngFor="let procedure of procedures" [value]="procedure.id" (click)="onSelection(procedure)" 
                        [ngClass]="{'active': selection != undefined && selection != null && procedure.id == selection.id } ">
                        <ul class="added">
                            <li class="active">
                                <div *ngIf="procedure.mostRecent">
                                    <span class="icon-plus"></span> New
                                </div>
                            </li>
                        </ul>
                        <div class="title">{{procedure.name}}</div>
                        <ul class="details">
                            <li class="modified">
                                <span class="label">Description</span>
                                <span class="value">{{ procedure.description}}</span>
                            </li> 
                            <li class="modified">
                                <span class="label">Last Modified</span>
                                <span class="value">{{ procedure.modifiedDate == null ? "&nbsp;" : ( procedure.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                            </li> 
                        </ul> 
                    </li> 
                </ul>
            </div> 
            <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }"> 
                <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                    <div class="header">
                        <div class="title">
                            {{ adminActionLabelText }}	
                            <button class="primary compact" [disabled]="!deleteButtonEnabled" (click)="confirmModalActive = true" ><span class="icon-trash btn-Icon"></span>{{ adminActionButton1LabelText }}</button>
                            <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
                        </div>
                    </div>
                    <div>
                        <form #procedureEditForm="ngForm" (ngSubmit)="onSave()">
                            <section>
                                <div class="body">
                                    <div class="form-group">
                                        <label>Procedure</label>
                                        <input maxlength="50" type="text" required name="procedurename"  [readonly]="readOnly" [(ngModel)]="selectedName">
                                    </div>
                                    <div class="form-group">
                                        <label>Description</label>
                                        <input maxlength="250" type="text" required name="proceduredescription" [readonly]="readOnly" [(ngModel)]="selectedDescription">
                                    </div>
                                </div>
                                <div class="footer">
                                    <div>
                                        <label class="errormsg">{{ getErrorMessage() }}</label> 
                                    </div>
                                    <button class="primary" type="submit" [disabled]="!procedureEditForm.form.valid || !procedureEditForm.dirty || !saveButtonEnabled">
                                        <span class="icon-plus"></span> Save</button>
                                    <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                        <span class="icon-cancel"></span> Cancel</button>
                                </div>
                            </section>
                        </form>
                    </div>      
                </div>
            </div>
        </div>
    </div>
</div>
